import React, { useEffect, Fragment } from "react";
import ImageGalleryT from "../../components/ImageGalleyT";
import Slider from "../../components/Slider";
import {
  ShareButton as ShareIcon,
  //ShareLike as SLike,
  ShareFacebook as SFacebook,
  ShareTwitter as STwitter,
} from "../../components/Icons";
import subCategorias from "../../data/subCategorias.json";
import Header from "../../components/layout/Header";

import {
  getDetalleArticuloR as getDetalleArt,
  convertToPrice as getPrecio,
  decodeToNumber as dToNumber,
  jsonDeserialize,
} from "../../API/request";
import Loading from "../../components/Loading";
import Legal from "../../components/Legal";
import { useDispatch } from "react-redux";
import { fetchArts } from "../../redux/slices/articulosSlice";
import Modal from "../../components/Modal";

const Details = (props) => {
  const [showLoading, setShowLoading] = React.useState(true);
  const [showSocialBtns, setShowVersion] = React.useState("");
  const [detalleArticulo, setDetalleArticulo] = React.useState(null);
  const [collectionDetalle, setCollectionDetalle] = React.useState("");
  const [categoriaActual, setCategoriaActual] = React.useState(null);
  const [modalOpen, setModalOpen] = React.useState(false);

  const abrirModal = () => setModalOpen(true);
  const cerrarModal = () => setModalOpen(false);

  const articleId = props.match.params.article;
  const showPrice = process.env.REACT_APP_SHOW_PRICE === "false" ? false : true;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchArts());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowLoading(true);
    setDetalleArticulo(null);
    setCollectionDetalle(null);
    setCategoriaActual(null);

    getDetalleArt(dToNumber(articleId))
      .then((responseDetalleArticulo) => {
        let detArticulo = jsonDeserialize(responseDetalleArticulo.data.data);
        const descripcionCorta = detArticulo.DescripcionLarga?.split("||")[0].trim();
        detArticulo.descripcion = descripcionCorta;
        setDetalleArticulo(detArticulo);

        setCollectionDetalle(detArticulo.catDetails);
        setCategoriaActual(detArticulo.catDetails.categoria);

        document.title = "Article - " + detArticulo.Nombre;

        setShowLoading(false);
        window.scrollTo(0, 0);
      })
      .catch((errorMessageGetMantenimiento) => {
        console.log("ERORR - En la petición");
      });
  }, [articleId, setShowLoading, setCollectionDetalle, setDetalleArticulo]);

  const showButtons = () => {
    showSocialBtns === "" ? setShowVersion("show") : setShowVersion("");
  };

  //const facebookLike = () => {
  //window.open("http://www.facebook.com/plugins/like.php?href=" + encodeURIComponent(document.URL) + "&amp");
  //showButtons();
  //}
  const facebookShare = () => {
    window.open(
      "https://facebook.com/sharer/sharer.php?u=" +
      encodeURIComponent(document.URL),
      "_blank"
    );
    showButtons();
  };
  const twitterShare = () => {
    window.open(
      "https://twitter.com/intent/tweet?url=" +
      encodeURI(document.URL) +
      "&text=" +
      document.title,
      "",
      "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600"
    );
    showButtons();
  };

  return (
    <Fragment>
      {showLoading ? (
        <Loading />
      ) : (
        <>
          {/* <HeaderExtended
            category={categoriaActual}
            menuType={false}
            listado={listadoCategorias}
            actual={categoriaActual}
          /> */}
          <Header
            showHeader
            showBtnBack
            menuType={false}
            listado={subCategorias}
            actual={categoriaActual}
          />
          <div className="content secondary">
            <div className="container">
              <div className="row row-cols-1 row-cols-md-2 details">
                {detalleArticulo.Activo ? (
                  <>
                    <div className="col details__image">
                      <ImageGalleryT
                        articuloNuevo={detalleArticulo.Nuevo}
                        imagesArticulo={
                          detalleArticulo.imgs.data[
                          detalleArticulo.imgs.data.length - 1
                          ]
                        }
                      />
                    </div>
                    <div className="col details__info">
                      <div className="details__info--share">
                        <div
                          className="details__info--share--button"
                          onClick={() => showButtons()}
                        >
                          <ShareIcon />
                        </div>
                        {/*<div className={"details__info--share--social " + showSocialBtns}  onClick={() => facebookLike()}>
                                                            <SLike />
                                                        </div>*/}
                        <div
                          className={
                            "details__info--share--social " + showSocialBtns
                          }
                          onClick={() => facebookShare()}
                        >
                          <SFacebook />
                        </div>
                        <div
                          className={
                            "details__info--share--social " + showSocialBtns
                          }
                          onClick={() => twitterShare()}
                        >
                          <STwitter />
                        </div>
                      </div>

                      <h1 className="o-1">{detalleArticulo.Nombre}</h1>
                      {showPrice && (
                        <h4 className="o-2">
                          {getPrecio(detalleArticulo.PrecioPublico)}
                        </h4>
                      )}
                      <span className="o-3">
                        {"No. de Articulo: " + detalleArticulo.NumParte}
                      </span>
                      <p className="o-4">{detalleArticulo.descripcion}</p>
                      <div className="btn--btn">
                        <button
                          className="btn-general btn-black mt-2 mt-md-3 mb-4"
                          onClick={abrirModal}
                        >
                          Más información
                        </button>
                      </div>
                      <Modal
                        show={modalOpen}
                        onClose={cerrarModal}
                        articulo={detalleArticulo}
                      />
                    </div>
                  </>
                ) : (
                  <h2>Articulo no disponible</h2>
                )}
              </div>
            </div>

            <Legal
              texto="Las imágenes son únicamente de referencia, algunas versiones pueden cambiar según el modelo del vehículo. Para mayor información sobre versiones, accesorios, precios, promociones y disponibilidad de nuestros productos se recomienda acudir a tu Distribuidor Autorizado Audi dentro de la República Mexicana."
              txtBoton="Contacto"
              urlBoton={process.env.REACT_APP_FORMULARIO_CONTACTO_PATH + articleId}
            />

            <div className="d-separator"></div>

            <Slider
              title="Más"
              articulos={collectionDetalle.articulos.data}
              showPrice={showPrice}
            />
          </div>
        </>
      )}
    </Fragment>
  );
};

export default Details;
